export default "__VITE_ASSET__C_kkeNqh__"